export const GET_PROGRAM_INSTITUTIONS = 'GET_PROGRAM_INSTITUTIONS';
export const GET_PROGRAM_INSTITUTION_BY_ID = 'GET_PROGRAM_INSTITUTION_BY_ID';
export const UPDATE_PROGRAM_INSTITUTION = 'UPDATE_PROGRAM_INSTITUTION';
export const DELETE_PROGRAM_INSTITUTION = 'DELETE_PROGRAM_INSTITUTION';
export const CREATE_PROGRAM_INSTITUTION = 'CREATE_PROGRAM_INSTITUTION';
